// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `Plaintext` component is used to show regular text, without any formatting options and ignoring html tags.
 * @since 0.0.42
 */
const Plaintext = ({
  baseClassName,
  className,
  children
}) => /*#__PURE__*/React.createElement("pre", {
  className: classNames(baseClassName, className)
}, children);

Plaintext.propTypes = {
  /**
   * Content of the Plaintext
   * @since 0.0.42
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Plaintext.defaultProps = {
  className: null,
  baseClassName: `${CLS_PREFIX}plaintext`
};
export default Plaintext;